import React, { useState, useEffect } from 'react';
import Modal from 'react-modal'; // Import the modal component
import * as styles from './analytics.module.css';
import { StaticImage } from 'gatsby-plugin-image';

const AnalyticsThumbnail = ({
  EmbeddedCasestudyVideoListing = [],
  activeVideo = [],
}) => {
  // State variables for managing the modal
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [preloadedImages, setPreloadedImages] = useState({});

  // Function to open the modal with the provided content
  const openModal = content => {
    setModalContent(content);
    setModalIsOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setModalIsOpen(false);
    setModalContent('');
  };

  // Preload images when component mounts
  useEffect(() => {
    if (activeVideo && activeVideo.dashboard) {
      const preloadImage = url => {
        const img = new Image();
        img.src = url;
        img.onload = () => {
          setPreloadedImages(prevImages => ({
            ...prevImages,
            [url]: img.src,
          }));
        };
      };

      preloadImage(activeVideo.dashboard);
    }
  }, [activeVideo]);

  return (
    <div className={styles.analyticsCasestudy}>
      <div
        className={`${
          activeVideo && activeVideo.videoOrientation === 'vertical'
            ? styles.analyticsContainerVertical
            : styles.analyticsContainer
        }`}
      >
        <span className={styles.analyticsTitle}>Analytics</span>
        <div className={styles.analyticsThumbnailContainer}>
          {/* Add onClick event handlers to the thumbnails */}
          <img
            src={activeVideo && activeVideo?.analytics}
            className={`${
              activeVideo &&
              activeVideo.tryItOut?.includes('') &&
              activeVideo &&
              activeVideo.videoOrientation === 'vertical'
                ? styles.verticalNoDiyAnalytics
                : activeVideo &&
                  activeVideo.tryItOut?.includes('') &&
                  activeVideo
                ? styles.casestudyAnalyticsThumbnailNoDiy
                : activeVideo.videoOrientation === 'vertical'
                ? styles.analyticsThumbnailVertical
                : styles.analyticsThumbnail
            }`}
            onClick={() =>
              openModal(
                preloadedImages[activeVideo.dashboard] || activeVideo.dashboard
              )
            } // Open modal with preloaded image
          />
        </div>
      </div>
      {/* Modal component */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Analytics Modal"
        className={styles.modal}
        overlayClassName={styles.overlay}
        shouldCloseOnOverlayClick={true} // Enable closing the modal by clicking outside of it
      >
        <div className={styles.modalOverlayContent}>
          <div className={styles.modalTitle}>{activeVideo.title}</div>
          <div className={styles.modalContent}>
            <img
              src={modalContent}
              alt="Dashboard"
              className={styles.modalImage}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AnalyticsThumbnail;
